export default __webpack_public_path__ + "static/media/java.dbae4f1a.png";